/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {
  IconButton, useTheme, useMediaQuery, makeStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import clsx from 'clsx';
import Dinero from 'utils/Dinero';
import { moneyFormat } from 'views/motorcycle_rental/utils/helpers';

const useStyles = makeStyles((theme) => ({
  mapControls: {
    background: theme.palette.common.white,
    margin: theme.spacing(1),
    boxShadow: `0 2px ${theme.spacing(1.5)} 0 rgba(0, 0, 0, 0.22)`,
    borderRadius: theme.spacing(1),
    width: theme.spacing(6.25),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: theme.spacing(12.5),
    padding: '0 0',
    border: 'none',
  },
  zoomBtn: {
    fontSize: theme.typography.pxToRem(36),
    fontWeight: '100',
    color: theme.palette.grey[700],
    height: '50%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    border: 'none',
    background: theme.palette.common.white,
    cursor: 'pointer',
  },
  zoomIn: {
    borderBottom: '1px solid #9797974d',
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
  },
  zoomOut: {
    borderBottomLeftRadius: theme.spacing(1),
    borderBottomRightRadius: theme.spacing(1),
  },
}));

const useMapLogic = (props) => {
  const theme = useTheme();
  const classes = useStyles();
  const { rentals, selectedPlace } = props;
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const largeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  const [mapCardData, setMapCardData] = useState({ open: false });
  const [groupedRentals, setGroupedRentals] = useState();
  const [mapControlObj, setMapControlObj] = useState();

  const calculateMapCenter = (mapObj) => {
    if (typeof mapObj !== 'object') return;
    if (groupedRentals.length > 1) {
      // eslint-disable-next-line no-undef
      const bound = new google.maps.LatLngBounds();
      for (let i = 0; i < rentals.length; i++) {
        bound.extend(
          // eslint-disable-next-line no-undef
          new google.maps.LatLng(rentals[i].location.lat, rentals[i].location.lng),
        );
      }
      mapObj.fitBounds(bound);
    } else if (groupedRentals.length == 1) {
      mapObj.setCenter({
        lat: parseFloat(groupedRentals[0][0].location.lat),
        lng: parseFloat(groupedRentals[0][0].location.lng),
      });
      mapObj.setZoom(6);
    } else if (groupedRentals.length == 0) {
      // THIS WILL CAUSE AN ERROR IF NOT MODIFIED FROM THE BE RESPONSE
      if (selectedPlace) {
        if (selectedPlace.location.lat && selectedPlace.location.lng) {
          mapObj.setCenter({
            lat: parseFloat(selectedPlace.location.lat),
            lng: parseFloat(selectedPlace.location.lng),
          });
          mapObj.setZoom(6);
        } else {
          mapObj.setCenter({
            lat: 16.213487,
            lng: -35.759664,
          });
          mapObj.setZoom(0);
        }
      }
    }
  };

  const mapOptions = {
    fullscreenControl: false,
    mapTypeControl: false,
    panControl: false,
    streetViewControl: false,
    zoomControl: false,
    gestureHandling: largeScreen ? 'auto' : 'greedy',
  };
  const CustomMapControl = ({ map }) => (
    <div className={classes.mapControls}>
      <button
        type="button"
        className={clsx(classes.zoomBtn, classes.zoomIn)}
        onClick={() => map.setZoom(map.getZoom() + 1)}
      >
        <AddIcon />
      </button>
      <button
        type="button"
        className={clsx(classes.zoomBtn, classes.zoomOut)}
        onClick={() => map.setZoom(map.getZoom() - 1)}
      >
        <RemoveIcon />
      </button>
    </div>
  );

  const handleGoogleMapLoaded = (map, maps) => {
    calculateMapCenter(map);
    setMapControlObj(map);
    const controlButtonDiv = document.createElement('div');
    largeScreen && ReactDOM.render(<CustomMapControl map={map} />, controlButtonDiv); // skipcq: JS-0441
    map.controls[maps.ControlPosition.TOP_RIGHT].push(controlButtonDiv);
  };
  const handleMarkerClick = (rentalsGroup) => {
    const newSelectedRentals = rentalsGroup.map((rental) => ({
      ...rental,
      id: rental.id,
      image: {
        src: rental.image_url,
        alt: `${rental.vehicle_make.name} ${rental.vehicle_model.name}`,
      },
      title: rental.vehicle_make.name,
      subTitle: rental.vehicle_model.name,
      price: moneyFormat(Dinero(rental.price.rate_per_day)),
      hourly_price: rental.price.rate_per_hour
        ? moneyFormat(Dinero(rental.price.rate_per_hour))
        : null,
    }));
    setMapCardData({
      open: true,
      rentalsItems: newSelectedRentals,
    });
  };
  const handleMapCardClose = () => {
    setMapCardData({ open: false });
  };

  const getImgSrc = (rentalsGroup) => {
    let imgSrc = '';
    if (rentalsGroup[0].host.type === 'location') {
      imgSrc = '/imgs/er_icon_withBG.svg';
    } else {
      imgSrc = '/imgs/map/pin.svg';
    }
    return imgSrc;
  };
  const renderMapMarkers = () => groupedRentals?.map((rentalsGroup) => (
    <IconButton
      lat={+rentalsGroup[0].location.lat}
      lng={+rentalsGroup[0].location.lng}
      onClick={() => handleMarkerClick(rentalsGroup)}
    >
      <img src={getImgSrc(rentalsGroup)} alt="img" width="42px" height="42px" />
    </IconButton>
  ));
  const groupByLatLng = (bikes) => {
    const rentalsGroupedByLatLng = {};
    bikes.forEach((rental) => {
      const key = `${rental.location.lat} - ${rental.location.lng}`;
      if (rentalsGroupedByLatLng[key]) {
        rentalsGroupedByLatLng[key].push(rental);
      } else rentalsGroupedByLatLng[key] = [rental];
    });
    return Object.values(rentalsGroupedByLatLng);
  };
  useEffect(() => {
    if (!rentals) return;
    setGroupedRentals(groupByLatLng(rentals));
    handleMapCardClose();
  }, [rentals]);
  useEffect(() => {
    if (groupedRentals && mapControlObj) {
      calculateMapCenter(mapControlObj);
    }
  }, [groupedRentals, mapControlObj]);
  return {
    mapCardData,
    renderMapMarkers,
    handleGoogleMapLoaded,
    isTablet,
    handleMapCardClose,
    mapOptions,
  };
};

export default useMapLogic;
